import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { UserPlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const fakeMemberNames = [
  "Sarah Mitchell",
  "James Rodriguez",
  "Emily Chen",
  "Michael Thompson",
  "Jessica Williams",
  "David Park",
  "Amanda Foster",
  "Ryan Martinez",
  "Lauren Anderson",
  "Kevin Bryant",
  "Nicole Garcia",
  "Brandon Lee",
  "Ashley Kumar",
  "Tyler Johnson",
  "Samantha Davis",
  "Christopher Taylor",
  "Megan White",
  "Daniel Kim",
  "Rachel Brown",
  "Justin Wilson",
  "Olivia Martinez",
  "Matthew Scott",
  "Emma Robinson",
  "Joshua Turner",
  "Hannah Phillips",
  "Andrew Campbell",
  "Victoria Moore",
  "Nathan Harris",
  "Sophia Lewis",
  "Alexander Wright"
];

const getRandomTimeAgo = () => {
  const minutes = Math.floor(Math.random() * 45) + 1;
  return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
};

export const SocialProofNotification = () => {
  const [currentName, setCurrentName] = useState("");
  const [timeAgo, setTimeAgo] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Set initial random name and time
    setCurrentName(fakeMemberNames[Math.floor(Math.random() * fakeMemberNames.length)]);
    setTimeAgo(getRandomTimeAgo());
  }, []);

  useEffect(() => {
    if (isDismissed) return;

    // Show notification
    setIsVisible(true);

    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    // Cycle to next random name after 8 seconds
    const cycleTimer = setTimeout(() => {
      setCurrentName(fakeMemberNames[Math.floor(Math.random() * fakeMemberNames.length)]);
      setTimeAgo(getRandomTimeAgo());
      setIsVisible(true);
    }, 8000);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(cycleTimer);
    };
  }, [currentName, isDismissed]);

  if (!isVisible || isDismissed) return null;

  return (
    <Card className="fixed bottom-6 left-6 z-50 p-4 shadow-lg border-2 border-primary/20 animate-in slide-in-from-bottom-5 max-w-sm">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0">
          <UserPlus className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">
            {currentName} just joined!
          </p>
          <p className="text-xs text-muted-foreground">
            {timeAgo}
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="flex-shrink-0 h-6 w-6"
          onClick={() => setIsDismissed(true)}
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
    </Card>
  );
};
